import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53dfeff8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  name: 'Triangle',
  props: {
    color: null,
    direction: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(["triangle", {
      left: __props.direction === 'left',
      right: __props.direction === 'right',
      up: __props.direction === 'up',
      down: __props.direction === 'down'
    }])
  }, [
    _createElementVNode("path", {
      d: "M5.5853 1.11567C5.78348 0.821442 6.21651 0.821441 6.4147 1.11567L11.5372 8.72067C11.7609 9.05278 11.523 9.5 11.1225 9.5H0.877458C0.47703 9.5 0.239056 9.05278 0.46276 8.72067L5.5853 1.11567Z",
      fill: __props.color || '#5061FA'
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})